import { GroupType } from '../typings/domain';
import {
    BannerFormats,
    BannerSize,
    UpdateDataReach
} from '../typings/predictor';

export const FETCH_PREDICTOR = 'FETCH_PREDICTOR';
export type FETCH_PREDICTOR = typeof FETCH_PREDICTOR;

export interface FetchPredictorAction {
    type: FETCH_PREDICTOR;
    groupId: string;
    campainId: string;
}

export function fetchPredictor(
    groupId: string,
    campainId: string
): FetchPredictorAction {
    return {
        type: FETCH_PREDICTOR,
        groupId,
        campainId
    };
}

export const FETCH_PREDICTOR_RECOMMENDATION = 'FETCH_PREDICTOR_RECOMMENDATION';
export type FETCH_PREDICTOR_RECOMMENDATION = typeof FETCH_PREDICTOR_RECOMMENDATION;

export interface FetchPredictorRecommendationAction {
    type: FETCH_PREDICTOR_RECOMMENDATION;
    groupId: string;
    campainId: string;
}

export function fetchPredictorRecommendation(
    groupId: string,
    campainId: string
): FetchPredictorRecommendationAction {
    return {
        type: FETCH_PREDICTOR_RECOMMENDATION,
        groupId,
        campainId
    };
}

export const CLOSE_PREDICTOR_RECOMMENDATION = 'CLOSE_PREDICTOR_RECOMMENDATION';
export type CLOSE_PREDICTOR_RECOMMENDATION = typeof CLOSE_PREDICTOR_RECOMMENDATION;

export interface ClosePredictorRecommendationAction {
    type: CLOSE_PREDICTOR_RECOMMENDATION;
    groupId: string;
}

export function closePredictorRecommendation(
    groupId: string
): ClosePredictorRecommendationAction {
    return {
        type: CLOSE_PREDICTOR_RECOMMENDATION,
        groupId
    };
}

export const UPDATE_PREDICTOR_REACH = 'UPDATE_PREDICTOR_REACH';
export type UPDATE_PREDICTOR_REACH = typeof UPDATE_PREDICTOR_REACH;

export interface UpdatePredictorReachAction {
    type: UPDATE_PREDICTOR_REACH;
    data: UpdateDataReach;
}

export function updatePredictorReach(
    data: UpdateDataReach
): UpdatePredictorReachAction {
    return {
        type: UPDATE_PREDICTOR_REACH,
        data
    };
}

export const UPDATE_BANNERS_PREDICTOR = 'UPDATE_BANNERS_PREDICTOR';
export type UPDATE_BANNERS_PREDICTOR = typeof UPDATE_BANNERS_PREDICTOR;

export interface UpdateBannersPredictorAction {
    type: UPDATE_BANNERS_PREDICTOR;
    groupId: string;
    data?: BannerSize[];
}

export function updateBannersPredictor(
    groupId: string,
    data?: BannerSize[]
): UpdateBannersPredictorAction {
    return {
        type: UPDATE_BANNERS_PREDICTOR,
        groupId,
        data
    };
}

export const SHOW_PREDICTOR_REACH_ERROR = 'SHOW_PREDICTOR_REACH_ERROR';
export type SHOW_PREDICTOR_REACH_ERROR = typeof SHOW_PREDICTOR_REACH_ERROR;

export interface ShowPredictorReachErrorAction {
    type: SHOW_PREDICTOR_REACH_ERROR;
    errorMassage: string;
    groupId: string;
}

export function showPredictorReachError(
    groupId: string,
    errorMassage: string
): ShowPredictorReachErrorAction {
    return {
        type: SHOW_PREDICTOR_REACH_ERROR,
        groupId,
        errorMassage
    };
}

export const UPDATE_PREDICTOR_REACH_RECOMMENDATION =
    'UPDATE_PREDICTOR_REACH_RECOMMENDATION';
export type UPDATE_PREDICTOR_REACH_RECOMMENDATION = typeof UPDATE_PREDICTOR_REACH_RECOMMENDATION;

export interface UpdatePredictorReachRecommendationAction {
    type: UPDATE_PREDICTOR_REACH_RECOMMENDATION;
    groupId: string;
    bannersFormats?: BannerFormats[];
}

export function updatePredictorRecommendationReach(
    groupId: string,
    bannersFormats?: BannerFormats[]
): UpdatePredictorReachRecommendationAction {
    return {
        type: UPDATE_PREDICTOR_REACH_RECOMMENDATION,
        groupId,
        bannersFormats
    };
}

export const SHOW_PREDICTOR_REACH_RECOMMENDATION_ERROR =
    'SHOW_PREDICTOR_REACH_RECOMMENDATION_ERROR';
export type SHOW_PREDICTOR_REACH_RECOMMENDATION_ERROR = typeof SHOW_PREDICTOR_REACH_RECOMMENDATION_ERROR;

export interface ShowPredictorReachRecommendationErrorAction {
    type: SHOW_PREDICTOR_REACH_RECOMMENDATION_ERROR;
    groupId: string;
    errorMessage?: string;
}

export function showPredictorRecommendationReachError(
    groupId: string,
    errorMessage?: string
): ShowPredictorReachRecommendationErrorAction {
    return {
        type: SHOW_PREDICTOR_REACH_RECOMMENDATION_ERROR,
        groupId,
        errorMessage
    };
}

export const FETCH_PREDICTOR_MAP = 'FETCH_PREDICTOR_MAP';
export type FETCH_PREDICTOR_MAP = typeof FETCH_PREDICTOR_MAP;

export interface FetchPredictorMapAction {
    type: FETCH_PREDICTOR_MAP;
    groupId: string;
    campainId: string;
    groupType: GroupType;
}

export function fetchPredictorMap(
    groupId: string,
    campainId: string,
    groupType: GroupType
): FetchPredictorMapAction {
    return {
        type: FETCH_PREDICTOR_MAP,
        groupId,
        campainId,
        groupType
    };
}

export const UPDATE_PREDICTOR_REACH_MAP = 'UPDATE_PREDICTOR_REACH_MAP';
export type UPDATE_PREDICTOR_REACH_MAP = typeof UPDATE_PREDICTOR_REACH_MAP;

export interface UpdatePredictorReachMapAction {
    type: UPDATE_PREDICTOR_REACH_MAP;
    data: UpdateDataReach;
}

export function updatePredictorReachMap(
    data: UpdateDataReach
): UpdatePredictorReachMapAction {
    return {
        type: UPDATE_PREDICTOR_REACH_MAP,
        data
    };
}

export const SHOW_PREDICTOR_REACH_OUTDOOR_ERROR =
    'SHOW_PREDICTOR_REACH_OUTDOOR_ERROR';
export type SHOW_PREDICTOR_REACH_OUTDOOR_ERROR = typeof SHOW_PREDICTOR_REACH_OUTDOOR_ERROR;

export interface ShowPredictorReachOutdoorErrorAction {
    type: SHOW_PREDICTOR_REACH_OUTDOOR_ERROR;
    errorMassage: string;
    groupId: string;
}

export function showPredictorReachOutdoorError(
    groupId: string,
    errorMassage: string
): ShowPredictorReachOutdoorErrorAction {
    return {
        type: SHOW_PREDICTOR_REACH_OUTDOOR_ERROR,
        groupId,
        errorMassage
    };
}

export type PredictorActions =
    | FetchPredictorAction
    | UpdatePredictorReachAction
    | FetchPredictorRecommendationAction
    | UpdatePredictorReachRecommendationAction
    | ShowPredictorReachErrorAction
    | ShowPredictorReachRecommendationErrorAction
    | ClosePredictorRecommendationAction
    | UpdateBannersPredictorAction
    | FetchPredictorMapAction
    | UpdatePredictorReachMapAction
    | ShowPredictorReachOutdoorErrorAction;
